import "./style.scss";
import { Table, Spin } from "antd";
import { useState } from "react";
import { TableTypes } from "./Table.model";
import { API_BASE_URL } from "../../../utilities/API_CONSTANT";
import { Http } from "../../../utilities/axios/http";
import { Assets } from "../../../assets";
import { formatThousands } from "../../../utilities/formatNUmber";

type PropsType = {
  data: any;
  columns: TableTypes;
  size?: "small" | "middle" | "large";
  pagination?: false | any;
  rowHoverable?: boolean;
  linkToExtract?: string;
};

export const DisplayTable = ({
  columns,
  data,
  size = "small",
  pagination = false,
  rowHoverable = false,
  linkToExtract,
}: PropsType) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleExtractClick = async () => {
    if (!linkToExtract) return;

    const url = `${API_BASE_URL}${linkToExtract}`;

    try {
      setIsDownloading(true);
      const res = await Http.getFile(url);

      const blob = new Blob([res.data], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "rapport.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="dis_table">
      {linkToExtract && (
        <div
          style={{
            marginBottom: "12px",
            textAlign: "right",
            marginRight: "24px",
            cursor: "pointer",
          }}
          className="extract-container"
        >
          {isDownloading ? (
            <Spin size="small" />
          ) : (
            <img
              src={Assets.icons.png.pdf}
              className="extract-icon"
              title="Télécharger PDF"
              width={"45px"}
              height={"50px"}
              onClick={handleExtractClick}
            />
          )}
        </div>
      )}
      <Table
        dataSource={data?.value}
        columns={columns}
        size={size}
        pagination={pagination}
        locale={{ emptyText: " Aucun résultat trouvé" }}
        rowHoverable={rowHoverable}
        rowClassName={(row) => {
          if (row?.isAuxiliary) return "ant-table-disable-row";
          return "";
        }}
        footer={() => (
          <div className="d-flex flex-column gap-2">
            {data?.totalLoad ? (
              <div
                className="w-full d-flex justify-content-between"
                style={{
                  fontSize: "12px",
                  borderBottom: "dashed 1px #d2d1d1",
                  paddingBottom: "8px",
                }}
              >
                <span> NOMBRE DE COLIS </span>
                <span> {data?.totalLoad} </span>
              </div>
            ) : (
              ""
            )}
            {data?.totalTonnage ? (
              <div
                className="w-full d-flex justify-content-between"
                style={{
                  fontSize: "12px",
                }}
              >
                <span> POIDS TOTAL EN TONNE (T) </span>
                <span
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  {formatThousands(data?.totalTonnage)} T{" "}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      />
    </div>
  );
};
